
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FileText } from 'lucide-react';
import { PageDetailsTab } from './PageDetailsTab';
import { useIsMobile } from '@/hooks/use-mobile';
import { DeepAnalysisResult } from '@/types/analysisTypes';

interface AnalysisTabsDisplayProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  pageAnalysisResult: DeepAnalysisResult;
  urlInput: string;
  analysisError: string | null;
}

export const AnalysisTabsDisplay: React.FC<AnalysisTabsDisplayProps> = ({
  activeTab,
  setActiveTab,
  pageAnalysisResult,
  urlInput,
  analysisError
}) => {
  const isMobile = useIsMobile();

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="animate-fade-in">
      <TabsList className="grid w-full grid-cols-1 bg-gradient-to-r from-teal-500/10 to-emerald-500/10 border border-teal-500/20 rounded-lg">
        <TabsTrigger 
          value="page-details" 
          className="transition-colors flex items-center gap-2 justify-center data-[state=active]:bg-gradient-to-r data-[state=active]:from-teal-500 data-[state=active]:to-emerald-500 data-[state=active]:text-white"
          data-testid="page-details-tab"
        >
          <FileText className="h-4 w-4" />
          {!isMobile && <span>Page Analysis Results</span>}
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="page-details" className="animate-fade-in mt-4">
        <PageDetailsTab
          pageAnalysisResult={pageAnalysisResult}
          urlInput={urlInput}
          errorMessage={analysisError}
        />
      </TabsContent>
    </Tabs>
  );
};
